import { HttpQuery } from "@/interfaces/httpQuery";
import { Role } from "@/interfaces/roles";
import { PermissionRoleTableMetadata } from "@/metadata/permisionRole";
import { messagesService } from "@/services/messages.service";
import { PERMISSION_ROLE_SERVICE } from "@/services/refactor/permission-role.service";
import { INITIAL_QUERY_STATE } from "@/utils/constants";
import {
  ActionsSubheaderComponent,
  TableAction,
  TableComponent,
  TableHeader,
  TablePagination
} from "helix-vue-components";
import { Component, Vue } from "vue-property-decorator";
import Template from "./PermissionManagementList.template.vue";
@Component({
  mixins: [Template],
  components: {
    TableComponent,
    ActionsSubheaderComponent
  }
})
export default class PermissionManagementListComponent extends Vue {
  public loading = true;
  public headers: TableHeader[] = PermissionRoleTableMetadata;
  public roles: Role[] = [];
  public pagination: TablePagination | null = null;
  public rowActions: TableAction[] = PERMISSION_ROLE_SERVICE.rowActions(
    this.triggerSearch
  );
  public generalActions: TableAction[] = PERMISSION_ROLE_SERVICE.generalActions();
  protected colors = ["white", "#f2f2f2", "#f2f2f2"];
  protected query: HttpQuery = { ...INITIAL_QUERY_STATE, embed: "users" };

  /**
   * Update requests on table page change event.
   * @param pagination: TablePagination
   */
  public onChangePage(pagination: TablePagination) {
    this.triggerSearch({
      sort: this.query.sort,
      page: pagination.currentPage,
      per_page: pagination.itemsPerPage
    });
  }

  /**
   * Update requests on column name click to sort.
   * @param header: TableHader
   */
  public filter(header: TableHeader) {
    this.triggerSearch({
      ...INITIAL_QUERY_STATE,
      sort: PERMISSION_ROLE_SERVICE.sortQuery(header)
    });
  }

  /**
   * Updates table data based on search component.
   * @param term: string
   */
  public onSearch(term: string) {
    this.triggerSearch({
      ...INITIAL_QUERY_STATE,
      "q[name_contains]": term
    });
  }

  /**
   * Takes action on serch bar close event.
   * @param update: boolean
   */
  public onClose(update: boolean) {
    if (update) {
      this.triggerSearch(INITIAL_QUERY_STATE);
    }
  }

  private async created() {
    this.triggerSearch();
  }

  private async triggerSearch(query?: HttpQuery) {
    this.loading = true;
    this.query = query || this.query;
    this.query.embed = "users";
    try {
      this.roles = await PERMISSION_ROLE_SERVICE.getRoles(this.query);
      this.pagination = await PERMISSION_ROLE_SERVICE.getPagination();
    } catch (error) {
      messagesService.renderErrorMessage(error);
    } finally {
      this.loading = false;
    }
  }
}
